$(window).on('load', function () {
    $('.timer[datetime]').each(function () {
        var $root = $(this);
        var dateTimeEl = $root.attr('datetime');

        function normalizeISO(s){
            if(!s) return s;
            s = s.replace(/^(\d{4})-(\d{1,2})-(\d{1,2})/, function(_,y,m,d){
                return y+'-'+String(m).padStart(2,'0')+'-'+String(d).padStart(2,'0');
            });
            s = s.replace(/([+-]\d{2})(\d{2})$/, '$1:$2');
            return s;
        }

        function parseCustomDate(str) {
            var iso = normalizeISO(str);
            var d = new Date(iso);
            if (!isNaN(d)) return d;
            var m = iso.match(/^(\d+)-(\d+)-(\d+)T(\d+):(\d+):(\d+)(?:\.\d+)?([+-])(\d{2}):?(\d{2})$/);
            if (!m) return null;
            var year=+m[1], month=+m[2], day=+m[3], hour=+m[4], min=+m[5], sec=+m[6];
            var sign = m[7]==='-'?-1:1, tzH=+m[8], tzM=+m[9];
            var offsetMin = sign*(tzH*60+tzM);
            return new Date(Date.UTC(year, month-1, day, hour, min, sec)-offsetMin*60000);
        }

        var targetDate = parseCustomDate(dateTimeEl);
        if (!targetDate || isNaN(targetDate)) return;

        var $days = $root.find('#days');
        var $hours = $root.find('#hours');
        var $minutes = $root.find('#minutes');
        var $seconds = $root.find('#seconds');
        var $expired = $root.find('.timer_expair_text');

        function showValues(){
            $root.find('span').not('.timer_expair_text').css('display','inline');
            $expired.hide();
        }
        function showExpired(){
            $root.find('span').not('.timer_expair_text').hide();
            $expired.show();
        }

        function updateCountdown() {
            var diff = targetDate - new Date();
            if (diff <= 0) {
                showExpired();
                $days.text('00'); $hours.text('00'); $minutes.text('00'); $seconds.text('00');
                return;
            }
            showValues();
            var d  = Math.floor(diff / 86400000);
            var h  = Math.floor((diff % 86400000) / 3600000);
            var m  = Math.floor((diff % 3600000) / 60000);
            var s  = Math.floor((diff % 60000) / 1000);
            $days.text(String(d).padStart(2,'0'));
            $hours.text(String(h).padStart(2,'0'));
            $minutes.text(String(m).padStart(2,'0'));
            $seconds.text(String(s).padStart(2,'0'));
        }

        updateCountdown();
        setInterval(updateCountdown, 1000);
    });
});